module.exports = __webpack_public_path__ + "static/media/ESCAPE 1_01.d85a2e2b.mp3";